<template>
  <div class="event-detail-container">
    <div class="event-header-compact">
      <img class="event-banner-compact" :src="event.image" :alt="event.name">
      <div class="event-status-pill" v-if="isUpcomingEvent(event.from*1000)">
        <font-awesome-icon icon="clock" class="status-icon" /> {{ $t('eventDetail.upcoming') }}
          </div>
      <div class="event-status-pill expired" v-if="isExpiredEvent(event.to*1000)">
        <font-awesome-icon icon="calendar-check" class="status-icon" /> {{ $t('eventDetail.expired') }}
        </div>
      <div class="event-status-pill active" v-if="!isUpcomingEvent(event.from*1000) && !isExpiredEvent(event.to*1000)">
        <font-awesome-icon icon="play-circle" class="status-icon" /> {{ $t('eventDetail.active') }}
      </div>
      <div class="event-header-row">
        <div class="event-type-icons-compact">
            <font-awesome-icon icon="swimmer" v-if="event.type==='Swim'" class="type-icon swim" />
            <font-awesome-icon icon="biking" v-if="event.type==='Ride'" class="type-icon bike" />
            <font-awesome-icon icon="running" v-if="event.type==='Run'" class="type-icon run" />
            <font-awesome-icon icon="walking" v-if="event.type==='Walk'" class="type-icon walk" />
            <span v-for="(type, idx) in event.type" :key="idx" class="type-icon-wrapper">
              <font-awesome-icon icon="swimmer" v-if="type=='Swim'" class="type-icon swim" />
              <font-awesome-icon icon="biking" v-if="type=='Ride'" class="type-icon bike" />
              <font-awesome-icon icon="running" v-if="type=='Run'" class="type-icon run" />
              <font-awesome-icon icon="walking" v-if="type=='Walk'" class="type-icon walk" />
            </span>
          </div>
        <div class="event-title-date">
          <span class="event-name-compact">{{ event.name }}</span>
          <span class="event-dates-compact">
            <font-awesome-icon icon="calendar-alt" class="date-icon" />
            {{ event.from * 1000 | formatTimestamp }} - {{ event.to * 1000 | formatTimestamp }}
          </span>
        </div>
      </div>
        </div>

    <div class="event-content-compact">
      <!-- Event Description -->
      <div v-if="event.description" class="event-description-compact">
        <div class="description-content-compact" v-html="event.description"></div>
      </div>

      <!-- Event Rules -->
      <div v-if="event.rules" class="event-rules-compact">
        <div class="rules-header-compact">
          <font-awesome-icon icon="bars" class="rules-icon" />
          <span class="rules-title-compact">{{ $t('eventDetail.scoringRules') }}</span>
        </div>
        <div class="rules-content-compact">
          <div
            v-for="(r, index) in event.rules"
            :key="`rule-${index}`"
            v-if="r.description && r.description.trim()"
            class="rule-item-compact"
          >
            <div class="rule-text-compact" v-html="r.description"></div>
          </div>
        </div>
      </div>

      <!-- Join Event Section -->
      <div class="join-form-container">
        <form @submit.prevent="join(event.slug)">

          <div class="form-grid">
            <!-- Join Code -->
            <div v-if="event.code_required" class="form-field">
              <label>Join Code</label>
              <input
                v-model="code"
                :placeholder="$t('eventDetail.joinCode')"
                type="text"
                required
              >
            </div>

            <!-- Level Selection -->
            <div v-if="event.levels" class="form-field">
              <label>Level</label>
              <select v-model="personal_level" required>
                <option value="" disabled>{{ $t('eventDetail.level') }}</option>
                <option
                  v-for="option in event.levels"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </select>
            </div>

            <!-- Team Selection -->
            <div v-if="event.teams" class="form-field">
              <label>Team</label>
              <select v-model="team_to_join" required>
                <option value="" disabled>{{ $t('eventDetail.team') }}</option>
                <option
                  v-for="team in event.teams"
                  :key="team.slug"
                  :value="team.slug"
                >
                  {{ team.name }}
                </option>
              </select>
            </div>

            <!-- Personal Target -->
            <div v-if="event.target_required" class="form-field">
              <label>Target</label>
              <input
                type="number"
                v-model="personal_target"
                :placeholder="$t('eventDetail.personalTarget')"
                required
              >
            </div>

            <!-- Pace Target -->
            <div v-if="event.personal_target_pace" class="form-field">
              <label>Pace</label>
              <input
                type="text"
                v-model="personal_target_pace"
                :placeholder="$t('eventDetail.paceTarget')"
                required
              >
            </div>
          </div>

          <button type="submit" class="join-button">
            {{ $t('eventDetail.join') }}
          </button>
        </form>
      </div>
    </div>
    <div v-if="error" class="error-message-compact error-message-desktop">
      <font-awesome-icon icon="exclamation-triangle" class="error-icon" /> {{ $t('eventDetail.error') }}: {{ error }}
    </div>
    <div class="dashboard-links-compact dashboard-links-desktop">
      <router-link v-if="!event.teams" class="btn-dashboard-compact btn-dashboard-desktop" :to="{name: 'eventDashboard', params:{slug: event.slug}}">
        <font-awesome-icon icon="tachometer-alt" class="btn-icon" />
        <font-awesome-icon icon="chart-bar" class="btn-icon" /> {{ $t('eventDetail.dashboard') }}
      </router-link>
      <router-link v-if="event.teams" class="btn-dashboard-compact btn-dashboard-desktop team" :to="{name: 'teamEventDashboard', params:{slug: event.slug}}">
        <font-awesome-icon icon="users" class="btn-icon" /> {{ $t('eventDetail.teamDashboard') }}
      </router-link>
      <router-link class="btn-dashboard-compact btn-dashboard-desktop var" :to="{name: 'eventVar', params:{event_slug: event.slug}}">
        <font-awesome-icon icon="table" class="btn-icon" /> {{ $t('eventDetail.varDashboard') }}
      </router-link>
    </div>

  </div>
</template>

<script>
import $backend from '../backend'
import DOMPurify from 'dompurify'

export default {
  name: 'EventDetail',
  metaInfo () {
    return {
      title: this.$t('eventDetail.title')
    }
  },
  data () {
    return {
      title: this.$t('eventDetail.title'),
      athlete: {},
      event: {},
      error: '',
      code: '',
      personal_target: '',
      personal_target_pace: '',
      personal_level: '',
      team_to_join: ''
    }
  },
  computed: {
    $isMobile () {
      return window.innerWidth <= 600
    },
    isLoggedIn () {
      return this.athlete && this.athlete.token && this.athlete.token !== 'undefined'
    }
  },
  watch: {
    '$i18n.locale' (newLocale, oldLocale) {
      let slug = this.$route.params.slug
      this.getEvent(slug)
    }
  },

  created () {
    // Allow viewing event details without login
    // Only set athlete if user is logged in
    if (localStorage.hasOwnProperty('athlete')) {
      const athleteData = localStorage.getItem('athlete')
      if (athleteData && athleteData !== 'undefined') {
        try {
          this.athlete = JSON.parse(athleteData)
        } catch (e) {
          console.error('Error parsing athlete data:', e)
          localStorage.removeItem('athlete')
        }
      }
    }

    // Clean up expired pending events
    this.cleanupExpiredPendingEvents()

    let slug = this.$route.params.slug
    this.title = this.title + ' | ' + slug
    this.getEvent(slug)
  },
  methods: {
    cleanupExpiredPendingEvents () {
      const pendingEvent = localStorage.getItem('pendingEvent')
      if (pendingEvent) {
        try {
          const eventData = JSON.parse(pendingEvent)
          // Check if the pending event is older than 1 minute
          if (Date.now() - eventData.timestamp > 1 * 60 * 1000) {
            console.log('Cleaning up expired pending event:', eventData.slug)
            localStorage.removeItem('pendingEvent')
          }
        } catch (e) {
          // Clear invalid pending event data
          console.log('Cleaning up invalid pending event data')
          localStorage.removeItem('pendingEvent')
        }
      }
    },
    isUpcomingEvent: function (fromTs) {
      return fromTs > Date.now()
    },
    isExpiredEvent: function (toTs) {
      return toTs < Date.now()
    },
    getEvent (slug) {
      $backend.getEvent(slug)
        .then(response => {
          this.event = response.data.event
          this.$emit('event-loaded', this.event)
        }).catch(error => {
          // Check if it's an unauthorized error - axios interceptor will handle redirect
          if (error && error.data && error.data.msg === 'unauthorized') {
            // Don't set error message here, let the interceptor handle the redirect
            return
          }
          // For other errors, display them
          this.error = error.data ? error.data.msg : 'An error occurred'
        })
    },
    getSanitizedRule (rule) {
      return DOMPurify.sanitize(rule.description, { ALLOWED_TAGS: ['b', 'i', 'ul', 'ol', 'li', 'strong', 'em', 'a'] })
    },
    join: async function (slug) {
      // Check if user is logged in before joining
      if (!this.isLoggedIn) {
        // Save current event to local storage for redirect after login
        const pendingEventData = {
          slug: slug,
          timestamp: Date.now()
        }
        localStorage.setItem('pendingEvent', JSON.stringify(pendingEventData))
        console.log('Saved pending event:', pendingEventData)
        this.$router.push({ name: 'login' })
        return
      }
      let opt = {}
      if (this.event.code_required) {
        opt.code = this.code
      }
      if (this.event.target_required) {
        opt.personal_target = this.personal_target
      }

      // validate personal level
      if (this.event.levels && (this.event.levels.length > 0)) {
        if (this.personal_level === '') {
          if (this.event.levels.length === 1) {
            this.personal_level = this.event.levels[0]
          } else {
            alert(this.$t('eventDetail.selectLevel'))
            return
          }
        }
        opt.personal_level = this.personal_level
      }

      if (this.event.teams && (this.event.teams.length > 0)) {
        if (this.team_to_join === '') {
          alert(this.$t('eventDetail.selectTeam'))
          return
        }
        opt.team_to_join = this.team_to_join
      }

      if (this.event.personal_target_pace) {
        if (this.personal_target_pace === '') {
          alert(this.$t('eventDetail.enterPaceTarget'))
          return
        }

        let pattern = /^\dp\d\d$/
        if (!pattern.test(this.personal_target_pace)) {
          alert(this.$t('eventDetail.invalidPaceTarget'))
          return
        }

        opt.personal_target_pace = this.personal_target_pace
      }

      // Token refresh is now handled automatically by the axios interceptor
      // No need to manually check token expiry here
      await $backend.join(this.athlete, slug, opt)
        .then(response => {
          // Clear any pending event since user successfully joined
          localStorage.removeItem('pendingEvent')

          if (this.event.teams && this.event.teams.length > 0) {
            this.$router.push({ name: 'teamEventDashboard', params: { slug: slug } })
          } else {
            this.$router.push({ name: 'eventDashboard', params: { slug: slug } })
          }
        }).catch(error => {
          console.log(this.event.teams)

          this.error = error.data.msg
          if (this.error === 'duplicated action') {
            // Clear any pending event since user already joined
            localStorage.removeItem('pendingEvent')

            if (this.event.teams && this.event.teams.length > 0) {
              this.$router.push({ name: 'teamEventDashboard', params: { slug: slug } })
            } else {
              this.$router.push({ name: 'eventDashboard', params: { slug: slug } })
            }
          }

          if (this.error === 'code mismatch') {
            this.error = this.$t('eventDetail.codeMismatch')
          }

          if (this.error === 'unauthorized') {
            this.$router.push({ name: 'login' })
          }
        })
    }
  }
}
</script>

<style lang="scss">
.event-detail-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 1rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.event-header-compact {
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
}
.event-banner-compact {
  width: 100%;
  height: 60vw;
  max-height: 340px;
  min-height: 180px;
  object-fit: contain;
  border-radius: 10px;
  transition: object-fit 0.3s;
}
.event-status-pill {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #e0e0e0;
  color: #333;
  font-size: 0.85rem;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.event-status-pill.expired {
  background: #ffe0e0;
  color: #c0392b;
}
.event-status-pill.active {
  background: #e0ffe0;
  color: #27ae60;
}
.event-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5rem;
  gap: 0.5rem;
}
.event-type-icons-compact {
  display: flex;
  gap: 0.3rem;
}
.type-icon {
  font-size: 1.2rem;
  padding: 0.2rem;
  border-radius: 50%;
  background: none;
}
.type-icon.swim { color: #00b4d8; }
.type-icon.bike { color: #06ffa5; }
.type-icon.run { color: #ff6b35; }
.type-icon.walk { color: #7209b7; }
.event-title-date {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.2rem;
}
.event-name-compact {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2c3e50;
}
.event-dates-compact {
  font-size: 0.95rem;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.event-content-compact {
  background: #fff;
  border-radius: 8px;
  box-shadow: none;
  padding: 1rem;
  width: 100%;
}
.event-description-compact {
  margin-bottom: 0.7rem;
  font-size: 0.98rem;
  color: #2c3e50;
  text-align: left;
}
.description-content-compact {
  font-size: 0.98rem;
  line-height: 1.4;
}
.event-rules-compact {
  margin-bottom: 1.2rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.rules-header-compact {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding-bottom: 0.8rem;
  border-bottom: 2px solid #e9ecef;
}
.rules-title-compact {
  font-weight: 700;
  color: #495057;
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.rules-icon {
  color: #6c757d;
  font-size: 1.2rem;
}
.rules-content-compact {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}
.rule-item-compact {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  padding: 0.8rem;
  background: #ffffff;
  border-radius: 8px;
  border-left: 4px solid #007bff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}
.rule-item-compact:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  border-left-color: #0056b3;
}
.rule-number-compact {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  border-radius: 50%;
  font-weight: 700;
  font-size: 0.9rem;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}
.rule-text-compact {
  flex: 1;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #495057;
  font-weight: 400;
}
.rule-text-compact strong,
.rule-text-compact b {
  color: #212529;
  font-weight: 600;
}
.rule-text-compact em,
.rule-text-compact i {
  color: #6c757d;
  font-style: italic;
}
.rule-text-compact a {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}
.rule-text-compact a:hover {
  text-decoration: underline;
  color: #0056b3;
}

.form-input-compact {
  font-size: 0.95rem;
  padding: 0.4rem 0.7rem;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  min-width: 90px;
  flex: 1 1 120px;
}

.error-message-compact {
  margin-top: 0.5rem;
  color: #c0392b;
  font-size: 0.95rem;
  background: #ffe0e0;
  border-radius: 5px;
  padding: 0.4rem 0.7rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.dashboard-links-compact {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 0.7rem;
}
.btn-dashboard-compact {
  background: #20c997;
  color: #fff;
  border-radius: 16px;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
    text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  transition: background 0.2s;
}
.btn-dashboard-compact.team {
  background: #ff6b35;
}
.btn-dashboard-compact:hover {
  background: #17a2b8;
    }
@media (max-width: 600px) {
  .event-detail-container {
    max-width: 100vw;
    padding: 0.5rem 0.1rem;
    text-align: center;
    align-items: center;
  }
  .event-banner-compact {
    height: 38vw;
    min-height: 90px;
    max-height: 180px;
    object-fit: contain;
  }
  .event-header-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.2rem;
  }
  .event-title-date {
    align-items: flex-start;
  }
  .event-content-compact {
    padding: 0.5rem;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .event-type-icons-compact {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .join-form-compact {
    flex-direction: column;
    align-items: stretch;
  }
  .form-input-compact {
    min-width: 0;
    width: 100%;
  }
  /* Improved mobile level selection */
  .mobile-level-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
  }
  .mobile-level-label {
    font-size: 0.98rem;
    font-weight: 500;
    color: #357abd;
    margin-bottom: 0.2rem;
    margin-left: 2px;
  }
  .mobile-level-select {
    border: 2px solid #357abd;
    border-radius: 7px;
    padding: 0.5rem 0.7rem;
    font-size: 1.05rem;
    background: #f7fbff;
    color: #2c3e50;
    margin-bottom: 0.2rem;
    appearance: none;
    outline: none;
  }
  .dashboard-links-compact {
    flex-direction: column;
    align-items: stretch;
    gap: 0.3rem;
  }

  /* Mobile styles for rules section */
  .event-rules-compact {
    padding: 0.8rem;
    margin-bottom: 1rem;
  }
  .rules-header-compact {
    margin-bottom: 0.8rem;
    padding-bottom: 0.6rem;
  }
  .rules-title-compact {
    font-size: 1rem;
  }
  .rule-item-compact {
    padding: 0.6rem;
    gap: 0.6rem;
  }
  .rule-number-compact {
    width: 24px;
    height: 24px;
    font-size: 0.8rem;
  }
  .rule-text-compact {
    font-size: 0.9rem;
    line-height: 1.4;
  }
}
/* Simple Join Form Styles */
.join-form-container {
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-field label {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.form-field input,
.form-field select {
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  background: #fff;
  transition: border-color 0.2s ease;
}

.form-field input:focus,
.form-field select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.join-button {
  width: 100%;
  padding: 1rem 2rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.join-button:hover {
  background: #2563eb;
}

.join-button:active {
  background: #1d4ed8;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .join-form-container {
    margin: 1rem;
    padding: 1.5rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

/* Tablet responsive */
@media (min-width: 769px) and (max-width: 1024px) {
  .form-grid {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }
}

/* Desktop styles */
@media (min-width: 601px) {
  .error-message-desktop {
    margin: 1rem auto;
    font-size: 1rem;
    color: #dc2626;
    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
    border: 2px solid #fecaca;
    border-radius: 10px;
    padding: 1rem 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    max-width: 600px;
    box-shadow: 0 2px 10px rgba(220, 38, 38, 0.1);
    text-align: center;
    justify-content: center;
  }

  .dashboard-links-desktop {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    flex-shrink: 0;
    background: linear-gradient(135deg, rgba(249, 250, 251, 0.8) 0%, rgba(243, 244, 246, 0.6) 100%);
    border: 1px solid rgba(229, 231, 235, 0.5);
    border-radius: 16px;
    padding: 1.25rem 1.5rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    backdrop-filter: blur(10px);
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  .dashboard-links-desktop .router-link-exact-active {
    display: flex;
    justify-content: center;
  }

  .btn-dashboard-desktop {
    background: rgba(99, 102, 241, 0.05);
    color: #6366f1;
    border: 1.5px solid rgba(99, 102, 241, 0.2);
    border-radius: 12px;
    font-size: 0.9rem;
    font-weight: 500;
    padding: 0.75rem 1.25rem;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    box-shadow: 0 2px 12px rgba(99, 102, 241, 0.08);
    transition: all 0.3s ease;
    min-width: 160px;
    justify-content: center;
    position: relative;
    overflow: hidden;
  }

  .btn-dashboard-desktop.team {
    background: rgba(168, 85, 247, 0.05);
    border-color: rgba(168, 85, 247, 0.2);
    color: #a855f7;
    box-shadow: 0 2px 12px rgba(168, 85, 247, 0.08);
  }

  .btn-dashboard-desktop:hover {
    background: rgba(99, 102, 241, 0.1);
    color: #4f46e5;
    border-color: rgba(99, 102, 241, 0.4);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.15);
  }

  .btn-dashboard-desktop.team:hover {
    background: rgba(168, 85, 247, 0.1);
    color: #9333ea;
    border-color: rgba(168, 85, 247, 0.4);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(168, 85, 247, 0.15);
  }

  .btn-dashboard-desktop:active {
    transform: translateY(0);
  }
}
</style>
